import { update } from 'ramda';
import React from 'react';
import { EDCard } from '../../../../../../BaseComponents/Card/EDCard';
import EDCheckbox from '../../../../../../BaseComponents/Checkboxes/EDCheckbox';
import EDBox from '../../../../../../BaseComponents/EDBox/EDBox';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';
import { IFormData } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { ObjektVyKort } from '../../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import { checkDoubleBookingInfo } from '../Utils/AktivitetUtils';
import { IRow } from './RepeteraAktivitetForm/RepeteraAktivitetFormStep2';
import { themeColors } from '../../../../../../BaseComponents/ThemeProvider/AvenyThemeColors';

interface IProps {
  aktivitet: IFormData;
  values: IRepeteraAktivitetValues;
  setters: IRepeteraAktivitetSetters;
  rows: IRow[];
  setRows: (rows: IRow[]) => void;
}

interface IProps {
  aktivitet: IFormData;
  values: IRepeteraAktivitetValues;
  setters: IRepeteraAktivitetSetters;
  rows: IRow[];
  setRows: (rows: IRow[]) => void;
}

export interface IRepeteraAktivitetValues {
  datumFr: string;
  datumTi: string;
  weekValue: {
    name: string;
    value: number;
  } | null;
  mondayChecked: boolean;
  tuesdayChecked: boolean;
  wednesdayChecked: boolean;
  thursdayChecked: boolean;
  fridayChecked: boolean;
  saturdayChecked: boolean;
  sundayChecked: boolean;
}

interface IRepeteraAktivitetSetters {
  setDatumFr: React.Dispatch<React.SetStateAction<string>>;
  setDatumTi: React.Dispatch<React.SetStateAction<string>>;
  setWeekValue: React.Dispatch<
    React.SetStateAction<{
      name: string;
      value: number;
    } | null>
  >;
  setMondayChecked: React.Dispatch<React.SetStateAction<boolean>>;
  setTuesdayChecked: React.Dispatch<React.SetStateAction<boolean>>;
  setWednesdayChecked: React.Dispatch<React.SetStateAction<boolean>>;
  setThursdayChecked: React.Dispatch<React.SetStateAction<boolean>>;
  setFridayChecked: React.Dispatch<React.SetStateAction<boolean>>;
  setSaturdayChecked: React.Dispatch<React.SetStateAction<boolean>>;
  setSundayChecked: React.Dispatch<React.SetStateAction<boolean>>;
}

const RepeteraAktivitetDubbelbokning: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const rowCardSmallScreen = props.rows.map((item, index) => {
    const dubbelBokText = checkDoubleBookingInfo(item).Dubbelbokningar;

    return dubbelBokText ? (
      <EDCard key={item.id} cardInCard>
        <EDBox
          sx={{
            display: 'flex',
            width: '100%',
            borderLeft: `4px solid ${themeColors.orange[700]}`,
            padding: '7px 12px 10px 0',
            marginBottom: '20px',
            marginTop: '20px',
          }}
        >
          <EDBox
            sx={{ display: 'flex', alignItems: 'center', paddingRight: 2 }}
          >
            <EDCheckbox
              checked={Boolean(item.Vald)}
              onCheck={checked => {
                const updatedRows = update(
                  index,
                  {
                    ...item,
                    Vald: checked,
                  },
                  props.rows
                );
                props.setRows(updatedRows);
              }}
            />
          </EDBox>

          <EDBox
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <EDBox
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                width: '100%',
              }}
            >
              <EDTypography>
                <strong>
                  {item.Rubrik ?? item.Boknr} {item.Datum}
                </strong>{' '}
                med:
              </EDTypography>
            </EDBox>
            <EDTypography>
              {dubbelBokText.split('\n').map((line, lineIndex) => (
                <React.Fragment key={lineIndex}>
                  {line.split(',').map((part, partIndex, array) => (
                    <React.Fragment key={partIndex}>
                      {part}
                      {partIndex < array.length - 1 && (
                        <EDTypography
                          sx={{
                            verticalAlign: 'middle',
                          }}
                          component="span"
                          fontSize={'20px'}
                          color="black"
                        >
                          {' · '}
                        </EDTypography>
                      )}
                    </React.Fragment>
                  ))}
                  <br />
                </React.Fragment>
              ))}
            </EDTypography>
          </EDBox>
        </EDBox>
      </EDCard>
    ) : undefined;
  });

  return (
    <>
      <EDBox>
        <ObjektVyKort noMargin caption="Vill du dubbelboka:"></ObjektVyKort>
      </EDBox>
      {rowCardSmallScreen}
    </>
  );
};

export default RepeteraAktivitetDubbelbokning;
